export const TERRAIN_TYPES = [
  "deep-water", "shallow-water", "hill-climb-or-descent", "unknown",
  "deep-ruts", "smooth-gravel", "embedded-rock", "loose-rock",
  "rock-garden", "mud", "sand", "whoops",
  "washboard", "twisties", "switchbacks", "dunes",
  "obstacles", "fast", "slow-technical", "single-track",
  "double-track", "public-roads", "highway", "woods",
] as const;

export type TerrainType = typeof TERRAIN_TYPES[number];

export const TERRAIN_LABELS: Record<TerrainType, string> = {
  "deep-water": "Deep Water",
  "shallow-water": "Shallow Water",
  "hill-climb-or-descent": "Hill Climb or Descent",
  "unknown": "Unknown",
  "deep-ruts": "Deep Ruts",
  "smooth-gravel": "Smooth Gravel",
  "embedded-rock": "Embedded Rock",
  "loose-rock": "Loose Rock",
  "rock-garden": "Rock Garden",
  "mud": "Mud",
  "sand": "Sand",
  "whoops": "Whoops",
  "washboard": "Washboard",
  "twisties": "Twisties",
  "switchbacks": "Switchbacks",
  "dunes": "Dunes",
  "obstacles": "Obstacles",
  "fast": "Fast",
  "slow-technical": "Slow / Technical",
  "single-track": "Single Track",
  "double-track": "Double Track",
  "public-roads": "Public Roads",
  "highway": "Highway",
  "woods": "Woods",
};
